import { Flex, Input, Text } from '@chakra-ui/react';
import { useState } from 'react';

export interface EditTitleProperties {
  title: string;
  setTitle?: (title: string) => void;
  placeholder?: string;
  onTitleChange?: (title: string) => void;
  showLabel?: boolean;
}
const EditTitle = ({
  title,
  setTitle,
  onTitleChange,
  placeholder = '',
  showLabel = true,
}: EditTitleProperties) => {
  const [newTitle, setNewTitle] = useState(title);

  const handleChange = (event: any) => {
    setNewTitle(event);
    if (onTitleChange) {
      onTitleChange(event);
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && setTitle) {
      setTitle(newTitle);
    }
  };

  const handleBlur = () => {
    if (setTitle) setTitle(newTitle);
  };

  return (
    <Flex flexDir={'column'}>
      {showLabel && (
        <Text color={'black.800'} fontWeight={'600'} mb={1}>
          Title
        </Text>
      )}

      <Input
        placeholder={placeholder || 'Title...'}
        color={'black.600'}
        px={'4px'}
        borderRadius='6px'
        fontWeight={500}
        outline={'2px solid transparent'}
        fontSize={'medium'}
        fontFamily={'regular_roboto'}
        autoFocus
        border={'2px solid #E2E8F0'}
        background={'#F7FAFC'}
        outlineOffset={'2px'}
        value={newTitle}
        onChange={(event) => handleChange(event.target.value)}
        onKeyPress={handleKeyPress}
        onBlur={handleBlur}
      />
    </Flex>
  );
};

export default EditTitle;
